@if (eventService.nextEvents().length > 0) {
  <div mat-content class="mat-body-2">
    <mat-card class="news-next">
      <mat-card-title class="top-title">
        <span>Aktuelle Termine</span>
        <!-- <button mat-icon-button><mat-icon class="material-icons-outlined">info</mat-icon></button>  -->
      </mat-card-title>
      @for (event of eventService.nextEvents(); track event; let isLast = $last) {
        <mat-card-title>
          @switch (event.isOneDayEvent) {
            @case (true) {
              <!-- one day event-->
              {{event.tsEventStart | date:'shortDate'}}
              @if (event.allDayEvent !== true) {
                <span>
                  , {{event.tsEventStart |date:'shortTime'}} -
                  {{event.tsEventEnd |date:'shortTime'}}
                </span>
              }
            }
            @case (false) {
              <!-- multi day event-->
              {{event.tsEventStart | date:(event.allDayEvent ===
              true ?
              'shortDate' : 'short')}}
              @if (event.tsEventEnd) {
                <span>
                  - {{event.tsEventEnd |date:(event.allDayEvent
                  === true ?
                  'shortDate' : 'short')}}
                </span>
              }
            }
          }
        </mat-card-title>
        <mat-card-content>
          <div class="event-title">{{event.title}}</div>
          @if (event.subTitle) {
            <div>{{event.subTitle}}</div>
          }
          @if (event.description) {
            <!-- <span class="event-table-description">{{event.description}}</span> -->
            <!-- <div>{{event.description}}</div> -->
            <markdown class="markdown regular" [data]="event.description" [disableSanitizer]="true"></markdown>
          }
          @if (event.url) {
            <div style="margin-top:8px;">
              <a mat-button href="{{event.url}}" target="_blank">{{event.url}}</a>
            </div>
          }
        </mat-card-content>
        @if (!isLast) {
          <mat-divider></mat-divider>
        }
      }
    </mat-card>
    <div class="actions">
      <button mat-button color="accent" routerLink="/termine"><mat-icon>event</mat-icon>Alle Termine</button>
    </div>
  </div>
}